import { StoreState } from '@futrli/auth';
import { useSelector } from 'react-redux';
import { TransformedAuth0User } from '../authenticator';

export const useSelectCurrentUser = () => {
  const user = useSelector((state: StoreState) => {
    return state?.authReducers?.authenticatedUser as TransformedAuth0User;
  });

  return user;
};
